export enum CookieName {
    LZAuthCookie = 'LZAuthCookie',
    USERIDENTIFICATION = 'LZUserIdentification',
    TIMESTRING1 = 'TIMESTRING'
}
export enum ProductName {
    LLC = 'llc',
    TM = 'tm',
    LWT = 'lwt'
}
